<div class="mdk-drawer-layout__content page">
    <div class="container-fluid page__heading-container">
        <div
            class="page__heading d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-lg-between text-center text-lg-left">
            <h1 class="m-lg-0">Blogs</h1>
            <button class="btn btn-primary ml-lg-3 float-right"
                *ngIf="userService.rolesArrayPermission.includes('addBlog')" [routerLink]="['/blogs/addBlog']"><i
                    class="material-icons mr-2">add_circle</i>Add New</button>
        </div>
        <!-- [routerLink]="['/banner/addBanner', data?.id]" -->
    </div>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th width="100px">Start Date</th>
                            <th width="100px">End Date</th>
                            <th width="250px">Description</th>
                            <th width="100px">Status</th>
                            <th width="100px">Action</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="blogsList && blogsList.length > 0">
                        <tr *ngFor="let blog of blogsList; let index = index">
                            <td>{{index + 1}}</td>
                            <td>{{blog?.title}}</td>
                            <td>{{blog?.start_date}}</td>
                            <td>{{blog?.end_date}}</td>
                            <td>
                                <p [innerHTML]="blog?.description" class="desc mt-2"></p>
                            </td>
                            <td class="capitalize">{{blog?.status?.toLowerCase()}}</td>
                            <td>
                                <button class="btn bg-transparent" *ngIf="userService.rolesArrayPermission.includes('editBlog')"
                                    [routerLink]="['/blogs/addBlog', blog?.id]">
                                    <a class="edit" title="Edit" data-toggle="tooltip"><i class="material-icons">&#xE254;</i></a>
                                </button>
                                <button class="btn bg-transparent">
                                    <a class="view" title="view" data-toggle="tooltip"
                                        (click)="viewBlogDetails(viewBlogs, blog?.id)"><i
                                            class="material-icons">visibility</i></a>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #viewBlogs let-modal>
    <div class="modal-content">
        <div class="modal-body">
            <div class="container emp-profile">
                <form method="post">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="float-right" style="width: 80px;">
                                <input type="submit" *ngIf="userService.rolesArrayPermission.includes('editBlog')"
                                    [routerLink]="['/blogs/addBlog', viewBlog?.id]" class="profile-edit-btn"
                                    (click)="closeModal()" name="btnAddMore" value="Edit" />
                            </div>
                            <div class="profile-img">
                                <img [src]="imgURL" onerror="this.src='../../../assets/images/logo.svg'" alt="" />
                                <!-- <div class="file btn btn-sm btn-primary pointer mt-2 row" style="width: 25%;">
                                    <label class="pointer mb-0">Upload Banner</label>
                                    <input type="file" (change)="onFileSelect($event,cropeImage)" />
                                </div> -->
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-4"></div>
                                <div *ngIf="fileToReturn" class="mt-2 text-center pointer col-md-4">
                                    <button (click)="uploadBannerImage(viewBlog?.id)">Upload</button>
                                </div>
                                <div class="col-md-4"></div>
                            </div> -->
                        </div>

                        <div class="col-md-12">
                            <div class="profile-head">
                                <h5>
                                    {{viewBlog?.title}}
                                </h5>
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home"
                                            role="tab" aria-controls="home" aria-selected="true">About</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content profile-tab" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel"
                                    aria-labelledby="home-tab">
                                    <div class="row" *ngIf="viewBlog?.title">
                                        <div class="col-md-4">
                                            <label>Title</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBlog?.title}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBlog?.status">
                                        <div class="col-md-4">
                                            <label>Status</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBlog?.status?.toLowerCase()}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>Description</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p [innerHTML]="viewBlog?.description" class="mt-2 modalDesc"></p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBlog?.start_date">
                                        <div class="col-md-4">
                                            <label>Start Date</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBlog?.start_date}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBlog?.end_date">
                                        <div class="col-md-4">
                                            <label>End Date</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBlog?.end_date}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-footer">
                <button (click)="closeModal()" class="btn btn-primary float-right">OK</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- <ng-template #cropeImage let-close="close">
    <div class="modal-header">
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 2"
            (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)"
            (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary"
            (click)="close(); resetSelectedImage(fileInput)">Cancel</button>
        <button type="button" class="btn btn-outline-secondary" (click)="close()">Confirm</button>
    </div>
</ng-template> -->